import { useMemo } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { urlWelcomeMessageForm } from 'app/auth/components/onboarding/constants/routes'
import Feature from '@cbgms/base/feature-flags/Feature'
import { OnboardingStepKey, OnboardingStepStatus } from '@cbgms/api'
import { useGetOnboardingStepData } from 'app/auth/components/hooks/use-get-onboarding-step-data'
import { OnboardingMode } from 'app/auth/components/onboarding/steps/types.d'

const OnboardingRedirect = () => {
  const loc = useLocation()
  const onboardingStatus = useGetOnboardingStepData({ mode: OnboardingMode.OnboardingExistingShop, basePath: loc.pathname })
  const isOnOnboardingRoute = loc.pathname.includes('onboarding') || loc.pathname.includes('contact') || loc.pathname.includes('404')
  const shouldRedirect = useMemo(() => {
    // redirect when the welcome step is not in the completed or off state
    const welcomeStep = onboardingStatus.data?.Steps.find(step => step.Key === OnboardingStepKey.WelcomeScreen)
    return !!welcomeStep && welcomeStep.State !== OnboardingStepStatus.Completed && welcomeStep.State !== OnboardingStepStatus.Off
  }, [onboardingStatus.data])

  if (isOnOnboardingRoute || onboardingStatus.isLoading || !shouldRedirect) {
    return null
  }

  return (
    <Feature feature='onboarding-redirect'>
      <Redirect to={urlWelcomeMessageForm('/onboarding')} />
    </Feature>
  )
}

export default OnboardingRedirect
